import { useEffect, useState } from "react";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { Generico } from "../../components/Generico";
import { Menu } from "../../models/administracion/Menu";
import { InputComponent } from "../../components/InputComponent";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { Funcion } from "./Funcion";
import { EtiquetaUsuario } from "./EtiquetaUsuario";

export const MenuFuncion = ({ usuario = null, rol = null, generic, permss, toast, opcion = 'funcion', empresa = null, lista }) => {
    const omodel = new Menu();
    const { accionesTbl } = Generico();
    const [registers, setRegisters] = useState(null);
    const monitoreoService = new MonitoreoService();
    const [dialogAsignar, setDialogAsignar] = useState(false);
    const [item, setItem] = useState(null);
    const [dialogEtiqueta, setDialogEtiqueta] = useState(false);
    const { table, setLoading, setTotalRecords, lazyParams } = InputComponent({ registers, omodel, generic, permss });

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);
        let _lazyParams = lazyParams;
        monitoreoService.listado('admin/funcion-menu/menus', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegisters(res.data.registros);
            setLoading(false);
        });
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar && opcion === 'funcion')
            items.push({ label: 'Asignar funcionalidades', icon: 'pi pi-check', command: () => { setDialogAsignar(true) } });
        if (permss?.actualizar && ['empresa', 'usuario'].includes(opcion))
            items.push({ label: 'Asignar etiquetas', icon: 'pi pi-at', command: () => { setDialogEtiqueta(true) } });

        return [{ label: 'Opciones', items: items }];
    }

    return (
        <>
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                {table({ action01: accionesTbl, reg: setItem, items: itemsMenu() })}
            </Card>

            <Dialog visible={dialogAsignar} header={"Asignar menú-funcionalidad a usuario: " + item?.nombre} modal className="p-fluid modal-ssize" onHide={e => setDialogAsignar(false)}
                style={{ maxWidth: '900px' }}>
                <Funcion menu={item?.id} usuario={usuario} rol={rol} toast={toast} generic={generic} permss={permss} />
            </Dialog>

            <Dialog visible={dialogEtiqueta} header={"Etiquetas del menú: " + item?.nombre} style={{ maxWidth: '600px' }} modal className="p-fluid modal-ssize"
                onHide={e => setDialogEtiqueta(false)}>
                <EtiquetaUsuario menu={item?.id} toast={toast} generic={generic} permss={permss} empresa={empresa} opcion={opcion} lista={lista} usuario={usuario} />
            </Dialog>
        </>
    )
}
